import { useState, useEffect, useCallback } from 'react';
import { getOrganizationServiceUrl } from '../utils/api/organization_apis';
import { STATUS } from '../utils/api/sharedfunction';

/**
 * Custom hook to fetch organization service URL
 * @returns {Object} { organizationData, loading, error, refetch }
 */
export const useOrganizationServiceUrl = () => {
    const [organizationData, setOrganizationData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await getOrganizationServiceUrl();
            
            if (response.status === STATUS.SUCCESS) {
                setOrganizationData(response.data);
            } else {
                setError(response.error || 'Failed to fetch organization service URL');
            }
        } catch (err) {
            console.error('Error in useOrganizationServiceUrl:', err);
            setError(err.message || 'An unexpected error occurred');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Return refetch function to allow manual refresh
    const refetch = useCallback(() => {
        fetchData();
    }, [fetchData]);

    return {
        organizationData, // Contains: { organizationId, organizationName, agentServiceUrl }
        loading,
        error,
        refetch
    };
};